import Vue from 'vue';
import axios from "axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

const api = JSON.parse(document.getElementById('api').textContent);

function checkAgree(id) {
    return axios.post(api.agree, {id: id});
}

const downloadModal = new Vue({
    el: "#downloadModal",
    data: {
        row: {},
        agree: true,
        onload: false
    },
    methods: {
        submit: function (form) {
            this.onload = true;
            if (this.row.level === "C") {
                const action = document.getElementById(form).action;

                axios.post(action, {id: this.row.id}).then(response => {
                    setTimeout(() => {
                        this.onload = false;
                        $('#downloadModal').modal('hide');
                        this.$swal({
                            icon: 'success',
                            text: response.data
                        });
                    }, 500);
                });
            } else {
                setTimeout(() => {
                    this.onload = false;
                    $('#downloadModal').modal('hide');
                    document.getElementById(form).submit();
                }, 500);
            }
        }
    }
});

$('#downloadModal').on('hidden.bs.modal', function (e) {
    downloadModal.$data.row = {};
});

new Vue({
    el: "#app",
    methods: {
        openNDA: function (row) {
            downloadModal.$data.row = row;
            $.magnificPopup.close();
            checkAgree(row.id).then(() => {
                downloadModal.submit('wyForm');
            }).catch(() => {
                $('#downloadModal').modal('show');
            });
        },
        showLogin: function () {
            loginOpen();
            $.magnificPopup.close();
        },
        eval: function (func) {
            eval(func);
        },
        openDownload(link) {
            window.open(link, '_blank');
        }
    }
});
